module.exports = __webpack_public_path__ + "static/media/ChestBlue.9c51e5ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sprites/ChestBlue.png
// module id = 2748
// module chunks = 0